import { useMemo, useState } from "react";
import { Check, Close } from "@mui/icons-material";
import { Box, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const formatDate = (iso?: string) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleString();
};


interface ViewVisitProps {
    data: any[];
}
const ViewVisit = ({ data }: ViewVisitProps) => {
    const rowsPerPage = 15;
    const [page, setPage] = useState<number>(1);

    const pagedData = useMemo(() => {
        if (!Array.isArray(data)) return [];
        const start = (page - 1) * rowsPerPage;
        return data.slice(start, start + rowsPerPage);
    }, [data, page, rowsPerPage]);


    const pageCount = useMemo(() => {
        if (!Array.isArray(data) || data.length === 0) return 1;
        return Math.max(1, Math.ceil(data.length / rowsPerPage));
    }, [data, rowsPerPage]);

    return (
        <Box sx={{ width: "100%", p: 2 }}>
            <Paper elevation={2}>
                <TableContainer sx={{ minHeight: 640, maxHeight: "74vh" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Ruta</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Vendedor</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Fecha y hora</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Proximidad</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Codigo del cliente</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Razon social</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Nombre comercial</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Venta efectiva</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                pagedData.map((visit, idx) => {
                                    const status = visit.canceled ? "canceled" : visit.saveOrderSap ? "saved" : "pending";
                                    return (
                                        <TableRow key={visit.$key ?? `${page}-${idx}`}>
                                            <TableCell>
                                                <Typography>{visit?.userRouter || "-"}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{visit?.vendorName || "-"}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{formatDate(visit?.created_at)}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {visit?.showFlagDistance ?
                                                    <Close sx={{ color: "#ff5c5cff" }} /> :
                                                    <Check sx={{ color: "#5cff64ff" }} />
                                                }
                                                <Typography component="span" sx={{ ml: 1 }}>
                                                    {visit.distance?.toFixed(2) ?? "-"} m
                                                </Typography>

                                            </TableCell>
                                            <TableCell><Typography>{visit?.cardCode || "-"}</Typography></TableCell>
                                            <TableCell><Typography>{visit?.cardName || "-"}</Typography></TableCell>
                                            <TableCell><Typography>{visit?.cardFName || "-"}</Typography></TableCell>
                                            <TableCell>
                                                {
                                                    status !== "canceled" ?
                                                        <>
                                                            {status === "saved" && <Typography sx={{ color: "#4caf50", fontWeight: 600 }}>Guardada</Typography>}
                                                            {status === "pending" && <Typography sx={{ color: "#00aeff", fontWeight: 600 }}>Pendiente</Typography>}
                                                        </>
                                                        :
                                                        <>
                                                            {
                                                                visit.productsLength > 0
                                                                    ? <Typography sx={{ color: "#f44336", fontWeight: 600 }}>Cancelada</Typography>
                                                                    : <Typography sx={{ color: "#f44336", fontWeight: 600 }}>Orden de no compra</Typography>
                                                            }
                                                        </>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }

                            {(!Array.isArray(data) || data.length === 0) && (
                                <TableRow>
                                    <TableCell colSpan={11} sx={{ py: 6, textAlign: "center" }}>
                                        <Typography color="text.secondary">No hay registros para mostrar.</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                    <Pagination
                        count={pageCount}
                        page={page}
                        onChange={(_, val) => setPage(val)}
                        color="primary"
                        shape="rounded"
                    />
                </Box>
            </Paper>
        </Box>

    )
}
export default ViewVisit;